<div class="flex-column gap-32">
	@if (!settings) {
		<mat-spinner mode="indeterminate" diameter="30" class="mx-a mt-15"></mat-spinner>
	} @else {
		<app-card preCardTitle="Page Settings">
			<div *appCardContent class="settings-header-container">
				<div class="settings-header-title">
					<p>My Public Portal</p>
					<div class="settings-header-subtitle">
						<div class="flex-row align-items-center">
							<a class="ops-link" [href]="publicMapUrl" target="_new">{{ publicMapUrl }}</a>
							<button mat-icon-button
									color="accent"
									class="smaller"
									[matTooltip]="'Copy to clipboard'"
									[cdkCopyToClipboard]="publicMapUrl">
								<mat-icon>content_copy</mat-icon>
							</button>
						</div>
					</div>
				</div>
			</div>
		</app-card>

		<app-card preCardTitle="Banner Messages">
			<div *appCardContentRaw>
				<app-toggle-expansion-panel
						[expanded]="!settings.hideMessageBar"
						(expandedChange)="toggleMessageBar()"
						[indented]="true"
						primaryText="Show Public Messages"
						secondaryText="Displayed at the top of the page on the public portal">

					<mat-divider></mat-divider>
					<div class="field-row px-16">
						<div class="field-row-title">
							Scrolling Speed
						</div>
						<div class="field-row-element">
							<mat-form-field color="accent" subscriptSizing="dynamic">
								<mat-select [(ngModel)]="settings.scrollingSpeed"
											(ngModelChange)="updatePublicPortalSettings()"
								>
									<mat-option [value]="0">No Scrolling</mat-option>
									<mat-option [value]="1">Slow</mat-option>
									<mat-option [value]="2">Medium</mat-option>
									<mat-option [value]="3">Fast</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>

					<mat-divider></mat-divider>
					<div class="field-row px-16">
						<div class="field-row-title">
							New Message
						</div>
						<div class="field-row-element">
							<button mat-stroked-button
									(click)="createHeadline()">
								Write Message
							</button>
						</div>
					</div>

					@if (headlines?.length) {
						<mat-divider></mat-divider>
						<div class="flex-column py-8">
							@for (headline of headlines; track $index) {
								<app-headline [headline]="headline"
											  class="px-16"
											  (headlineDeleted)="deleteHeadline($index)"
											  (headlineUpdated)="updateHeadline($index, $event)"
											  (headlineSelected)="selectedHeadlineChanged($index, $event)">
								</app-headline>
								@if (!$last) {
									<mat-divider></mat-divider>
								}
							}
						</div>
					}
				</app-toggle-expansion-panel>
			</div>
		</app-card>

		<app-card preCardTitle="Left Panel Content">
			<div *appCardContentRaw>
				<app-toggle-expansion-panel
						[expanded]="!settings.hideLeftPanel"
						(expandedChange)="toggleLeftPanel()"
						[indented]="true"
						primaryText="Show Left Panel"
						secondaryText="Displayed on the left of the page on the public portal">

					<mat-divider></mat-divider>
					<div class="field-row align-items-center px-16">
						<div class="field-row-title">Logo</div>
						<div class="field-row-element flex-column align-items-end">
							@if (currentLogo?.length > 0) {
								<img [src]="getBase64Image()"
									 class="logo"
									 alt="Logo">
							}
							<input hidden="hidden"
								   #fileInput type="file" onclick="this.value=null"
								   (change)="fileInputChange($event)" accept="image/png,image/jpeg"/>
							<button mat-stroked-button
									[disabled]="savingLogo"
									(click)="fileInput.click()">
								Choose file
							</button>
						</div>
					</div>

					<mat-divider></mat-divider>
					<div class="field-row label-width-50 px-16">
						<div class="field-row-title">Logo Link</div>
						<div class="field-row-element">
							<mat-form-field subscriptSizing="dynamic"
											class="w-100">
								<input matInput
									   autocomplete="off"
									   type=text
									   placeholder="www.yourtown.org/snowinfo"
									   [(ngModel)]="settings.logoLink"
									   [ngModelOptions]="{updateOn: 'blur'}"
									   (ngModelChange)="updatePublicPortalSettings()"
								>
							</mat-form-field>
						</div>
					</div>

					<mat-divider></mat-divider>
					<div class="settings-header-container p-16">
						<div class="settings-header-title">
							<p>Content Block</p>
							<div class="settings-header-subtitle">Create a new set of content for the left panel</div>
						</div>
						<div class="settings-header-actions">
							<button mat-stroked-button (click)="createContentBlock()">Create Block</button>
						</div>
					</div>

					@if (settings.contentBlocks.length) {
						<mat-divider></mat-divider>
						<mat-radio-group class="headline-radio-buttons ">
							@for (contentBlock of settings.contentBlocks; track $index) {
								<div class="px-16">
									<app-content-block [contentBlock]="contentBlock"
													   class="w-100"
													   (contentBlockDeleted)="deleteContentBlock($index)"
													   (contentBlockUpdated)="updateContentBlock($index)"
													   (contentBlockSelected)="selectContentBlock($index)">
									</app-content-block>
								</div>
								@if (!$last) {
									<mat-divider></mat-divider>
								}
							}
						</mat-radio-group>
					}

				</app-toggle-expansion-panel>
			</div>
		</app-card>

		<app-card preCardTitle="Map Settings">
			<div *appCardContentRaw>
				<app-toggle-expansion-panel
						[(expanded)]="settings.showMapContent"
						(expandedChange)="updatePublicPortalSettings()"
						[indented]="true"
						primaryText="Show Map Content"
						secondaryText="Turn off to hide all activities from the public">

					<mat-divider></mat-divider>
					<div class="p-16">
						<app-toggle-expansion-panel
								[(expanded)]="settings.useMapThemes"
								(expandedChange)="onVehicleHistoryChange()"
								primaryText="Map Themes">

							<div class="indent pt-16">
								<app-row-with-toggle
										[(checked)]="settings.allowGpsTracks"
										(checkedChange)="onVehicleHistoryChange()"
										primaryText="GPS Tracks">
								</app-row-with-toggle>

								<app-row-with-toggle
										[(checked)]="settings.allowPassCountMap"
										(checkedChange)="onVehicleHistoryChange()"
										primaryText="Pass Count Map">
								</app-row-with-toggle>

								<app-row-with-toggle
										[(checked)]="settings.allowTimeMap"
										(checkedChange)="onVehicleHistoryChange()"
										primaryText="Time Since Last Pass Map">
								</app-row-with-toggle>

								<div class="py-12 pb-16">
									<app-toggle-expansion-panel
											[(expanded)]="settings.allowRouteStatusMap"
											(expandedChange)="onVehicleHistoryChange()"
											primaryText="Assignment Status">
										@if (settings.routeStatusLayerConfig) {
											<div class="ml-25 mt-8">
												<mat-form-field appearance="outline" color="accent" class="wide no-hint">
													<mat-label>Route Configuration</mat-label>
													<mat-select
															[(ngModel)]="settings.routeStatusLayerConfig.routeConfigurationId"
															(ngModelChange)="updatePublicPortalSettings()">
														@for (routeConfig of routeConfigurations; track $index) {
															<mat-option [value]="routeConfig.id">{{ routeConfig.name }}
															</mat-option>
														}
													</mat-select>
												</mat-form-field>

												<div class="mt-10">
													<span>Threshold when route is still serviced</span>
													<mat-slider min="1"
																max="24"
																step="1"
																showTickMarks
																discrete
																[displayWith]="formatServicedThresholdLabel(RouteStatusLayerConfig.THRESHOLD_VALUES)"
																color="accent"
																style="width: 95%"
													>
														<input matSliderThumb
															   [(ngModel)]="servicedThresholdIndex"
															   (change)="onServicedThresholdChange($event)"
														>
													</mat-slider>
												</div>
											</div>
										}
									</app-toggle-expansion-panel>
								</div>
							</div>
						</app-toggle-expansion-panel>
					</div>

					<mat-divider></mat-divider>
					<div class="p-16">
						<app-toggle-expansion-panel
								[(expanded)]="settings.showVehicleMarkers"
								(expandedChange)="updatePublicPortalSettings()"
								primaryText="Vehicles">

							@for (group of vehicleGroups; track $index) {
								<div class="pt-24">
									<app-toggle-expansion-panel
											[(expanded)]="group.selected"
											(expandedChange)="updateExcludedVehicleGroups()"
											[primaryText]="group.name"
											class="indented">
									</app-toggle-expansion-panel>
								</div>
							}
						</app-toggle-expansion-panel>
					</div>

					<mat-divider></mat-divider>
					<div class="px-16">
						<app-row-with-toggle
								[(ngModel)]="settings.showVehicleLabels"
								(ngModelChange)="updatePublicPortalSettings()"
								primaryText="Show Public Portal Aliases">
						</app-row-with-toggle>
					</div>

					<mat-divider></mat-divider>
					<app-toggle-expansion-panel
							[(expanded)]="showAdditionalMapLayers"
							[indented]="true"
							(expandedChange)="toggleAdditionalMapLayers()"
							primaryText="Additional Map Layers">

						<div class="settings-header-container p-16">
							<div class="settings-header-title">
								Layers
							</div>
							<div class="settings-header-actions gap-8">
								<button mat-flat-button
										[disabled]="!mapLayers.length"
										(click)="openMapPreview()">
									<mat-icon>map</mat-icon>
									Show Preview
								</button>
								<button mat-stroked-button
										(click)="addNewLayer()">
									Add Layer
								</button>
							</div>
						</div>

						@for (mapLayer of mapLayers; track $index) {
							<mat-menu #actionsMenu="matMenu">
								<button mat-menu-item
										(click)="removeMapLayer($index)">
									<mat-icon>delete</mat-icon>
									Remove
								</button>
								@if (!$last) {
									<button mat-menu-item
											(click)="moveMapLayerDown($index)">
										<mat-icon>south</mat-icon>
										Move Down
									</button>
								}
							</mat-menu>

							<mat-divider></mat-divider>
							<div class="flex-row align-items-center px-16 py-8">
								<div class="flex-grow-1">{{ mapLayer.name }}</div>

								<mat-slide-toggle [hideIcon]="true"
												  matTooltip="Toggle layer enable"
												  (change)="onEnabledChange(mapLayer)"
												  [checked]="mapLayer.publicEnabled">
								</mat-slide-toggle>
								<button mat-icon-button
										[matMenuTriggerFor]="actionsMenu">
									<mat-icon>more_vert</mat-icon>
								</button>
							</div>
						}
					</app-toggle-expansion-panel>

				</app-toggle-expansion-panel>
			</div>
		</app-card>

		<app-card preCardTitle="Embed Code">
			<div *appCardContent>
				<div class="embed-section wide">
					<div class="section-title flex-row align-items-center">
						Use this code to add our public portal to you existing public portal website
						<button mat-icon-button
								color="accent"
								class="smaller"
								[matTooltip]="'Copy to clipboard'"
								[cdkCopyToClipboard]="getIframeCode()">
							<mat-icon>content_copy</mat-icon>
						</button>
					</div>
					<pre class="iframe-block mb-0"><code>{{ getIframeCode() }}</code></pre>
				</div>
			</div>
		</app-card>

	}
</div>
